/**
 * @name channelUrl
 * @constant
 * @type string
 * @description Link to join the telegram channel
 */
export const channelUrl = 'https://t.me/chainOfEventsCommunity';